<h1 mat-dialog-title>{{ 'packagingUnit.packagingUnit' | transloco }}</h1>

<mat-dialog-content>
  <app-packaging-units-overview [dataSource]="dataSource" [displayedColumns]="displayedColumns"
    [isUserValidator]="false" (packagingPartsSelected)="packagingUnitsSelected($event)">
  </app-packaging-units-overview>
</mat-dialog-content>

<mat-dialog-actions>
  <button (click)="importPackagingUnits()" mat-raised-button type="submit" color="primary"
    [disabled]="selectedPackagingUnits.length === 0">
    {{ 'common.buttons.import' | transloco }}</button>
  <button (click)="closeDialog()" mat-raised-button type="button">
    {{ 'common.buttons.cancel' | transloco }}</button>
</mat-dialog-actions>
